import React from 'react';
import { IOrder, ITradeInVehicle } from 'next-common';
import { ModalState } from '../../HeaderEnum';
import { TradeInForm } from './TradeInForm';
import { CustomModal } from '@repo/ui/components';

interface ITradeInModalProps {
  order: IOrder;
  modal: number;
  toggleTradeIn?(value: boolean): void;
  setModal?(ModalState): void;
}

interface ITradeInDialogProps {
  orderId: string;
  tradeIns?: ITradeInVehicle[];
  className?: string;
  isModal?: boolean;
  isEditable?: boolean;
  title?: string;
  onClose?(): void;
}

export const TradeInDialog = (props: ITradeInDialogProps) => {
  const title = props.title
    ? props.title
    : props.isEditable
      ? `${props.tradeIns?.length > 0 ? 'Rediger' : 'Legg til'} innbyttebil`
      : 'Innbyttebil';

  return props.isModal ? (
    <CustomModal
      open={props.isModal}
      onCloseClick={props.onClose}
      headerTitle={'Legg til innbyttebil'}
      className="w-[30rem]"
    >
      <div className="p-6 flex flex-col gap-6 max-h-[calc(100vh_-_11rem)] overflow-y-auto noScrollbar">
        <TradeInForm isEditable={true} tradeIns={props.tradeIns} orderId={props.orderId} onClose={props.onClose} />
      </div>
    </CustomModal>
  ) : (
    <>
      {title ? <h2 className={'title'}>{title}</h2> : null}
      <TradeInForm isEditable={true} tradeIns={props.tradeIns} orderId={props.orderId} />
    </>
  );
};

export const TradeInModal = (props: ITradeInModalProps) => {
  const order = props.order;
  const tradeIns: ITradeInVehicle[] = order?.tradeInVehicles;
  return (
    <TradeInDialog
      orderId={order?.id}
      isModal={props.modal === ModalState.TRADEIN}
      tradeIns={tradeIns}
      onClose={() => props.toggleTradeIn(false)}
    />
  );
};
